import React, { useState, useEffect } from "react";
import { Progress } from "antd";
import ReportTableHeader from "../../componentsShared/ReportTableHeader";
import "./style.scss";

const ICON_DECREASE = require("../../assets/img/icons/ic-decrease-red.svg");
const ICON_INCREASE = require("../../assets/img/icons/ic-increase-green.svg");

const MyStoresOnShelfAvailabilityChart = (props) => {
  const [data, setData] = useState({});

  return (
    <div className="Total-Audits-Completed-wp">
      <div className="row">
        <div className="col-25">
          <Progress
            type="circle"
            percent={props.osa}
            strokeWidth={10}
            strokeColor={props.osa > 80 ? "#87d068" : "#E5305B"}
            format={() =>
              props.osa > 80 ? (
                <div style={{ color: "#87d068" }}>{props.osa}%</div>
              ) : (
                <div style={{ color: "#E5305B" }}>{props.osa}%</div>
              )
            }
            width={80}
          />
        </div>
        <div className="col-75">
          <div className="summary-completed-stores">On-Shelf Availability</div>
        </div>
      </div>
    </div>
  );
};

export default MyStoresOnShelfAvailabilityChart;
